module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-4-photo-6-9d07eabfb52abf2ba0a939bec8c57e82.webp";